export const WORK_ITEMS_UPDATED = 'property/WORK_ITEMS_UPDATED';
